import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  AfterViewChecked,
  ChangeDetectorRef,
  ViewChild,
  TemplateRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtsappService } from '@common/services/atsapp.service';
import { takeUntil } from 'rxjs';
import { TextsListFiltersComponent } from 'projects/speaker-platform/src/app/organisms/admin/texts-list-filters/texts-list-filters.component';
import { FiltersProps } from 'projects/speaker-platform/src/app/types/filters';
import { AbstractTextComponent } from '../../../common/abstract/abstract-texts.component';
import { DateTransformService } from 'projects/speaker-platform/src/app/services/helpers/date-transform.service';
import { PaginationComponent } from 'projects/speaker-platform/src/app/molecules/pagination/pagination.component';
import { TextsMenuComponent } from 'projects/speaker-platform/src/app/molecules/texts-menu/texts-menu.component';
import { TextsActions } from 'projects/speaker-platform/src/app/types/texts-actions.enum';
import { TextsTodo } from 'projects/speaker-platform/src/app/types/texts-todo.enum';
import { DialogComponent } from 'projects/speaker-platform/src/app/molecules/dialog/dialog.component';
import { LoaderComponent } from '@common/components/loader/loader.component';
import { SpeakerService } from 'projects/speaker-platform/src/app/services/helpers/speaker.service';
import { PostStatesComponent } from 'projects/speaker-platform/src/app/molecules/post-states/post-states.component';
import { Speaker } from '../../../types/speaker';
import { CcLibelleService } from '../../../services/helpers/cc-libelle-service.service';
import {NgbModal, NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import { TruncatePipe } from '../../../pipes/truncate.pipe';
import {CommonModalService} from "../../../services/helpers/common-modal.service";
import {TextFocusComponent} from "../../../organisms/text-focus/text-focus.component";
import {ToastService} from "@common/services/toast.service";

@Component({
  selector: 'app-texts-sent',
  imports: [
    CommonModule,
    TextsListFiltersComponent,
    PaginationComponent,
    TextsMenuComponent,
    DialogComponent,
    LoaderComponent,
    PostStatesComponent,
    NgbTooltip,
    TruncatePipe,
    TextFocusComponent,
  ],
  templateUrl: './texts-sent.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../../organisms/admin/texts-list/texts-list.component.scss']
})
export class TextsSentComponent
  extends AbstractTextComponent
  implements OnInit, OnDestroy, AfterViewChecked
{
  constructor(
    atsappService: AtsappService,
    dateTransformService: DateTransformService,
    protected speakerService: SpeakerService,
    ccLibelleService: CcLibelleService,
    private cdr: ChangeDetectorRef,
    private modalService : NgbModal,
    private commonModalService: CommonModalService,
    private toastService: ToastService,
  ) {
    super(atsappService, dateTransformService, ccLibelleService);
  }

  @ViewChild('textsListHeader') textsListHeader!: ElementRef;

  textsTodo = TextsTodo;
  smartSelectEnabled: boolean = false;

  prisesVoix: any[] = [];
  prisesVoixToExport: any[] = [];
  textsToSendList: string[] = [];
  actions = TextsActions;

  // Pagination informations
  page: number = 1;
  limit: number = 10;
  collectionSize: number = 0;

  selectedSpeaker!: Speaker;

  showValidationDialog: boolean = false;
  isPosting: boolean = false;
  isPostingOver: boolean = false;
  postError: { errorCode: number; message: string } | null = null;

  pvArrayToPost: Array<{
    RANG_PV: string;
    ZMS_DATEPVDIST1: string;
    ZMS_LIVRAISON: string;
    ZMS_MESSAGE: string;
    ZMS_NUMERO: string;
  }> = [];

  filters: any = {};
  langSelected: boolean = false;
  textsListHeaderHeight: string = '';

  postObjectKeys = [
    'ZMS_PVCHOIXCLIENT1',
    'RANGPV',
    'ZMS_NUMERO',
    'ZMS_LIVRAISON',
    'ZMS_MESSAGE',
    'ZMS_DATEPVDIST1',
    'ZMS_PVCODE1',
    'CODE_COMEDIENNE',
    'ZMS_LANGUE'
  ];

  textsForPreview: any[]= [];

  showFocusModalFromSent: boolean = false;

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.getPhasesVocale();
    this.getTypesMessage();
    this.getLangues();
    this.getSpeakers();
  }

  ngAfterViewChecked(): void {
    this.textsListHeaderHeight =
      this.textsListHeader.nativeElement.clientHeight + 'px';
    this.cdr.detectChanges();
  }

  onSelectLang(e: any) {
    if (e !== '') {
      this.langSelected = true;
      return;
    }
    this.langSelected = false;
  }

  getPVsList(filters: any = this.filters) {
    this.filters = filters;
    this.isLoading = true;
    this.atsappService
      .getAssignedPVs(this.filters, this.page, this.limit)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.prisesVoix = res.assigned_PVs;
          this.prisesVoix.sort((a, b) => {
            const nameA = a.ZMS_PVCODE1.toUpperCase();
            const nameB = b.ZMS_PVCODE1.toUpperCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            // names must be equal
            return 0;
          })
          this.collectionSize = parseInt(res.total);
          this.isLoading = false;
        },
        error: (err) => console.error(err),
        complete: () => this.resetTextsToPatchList(),
      });
  }

  exportPvSent(filters: any = this.filters) {
    this.filters = filters;
    this.isLoading = true;

    this.atsappService
        .getAssignedPVs(this.filters, 1, 1000000)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            if (res.assigned_PVs.length > 0) {
              this.prisesVoixToExport = res.assigned_PVs;
              this.prisesVoixToExport.sort((a, b) => {
                const nameA = a.ZMS_PVCODE1.toUpperCase();
                const nameB = b.ZMS_PVCODE1.toUpperCase();
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0;
              })
              this.createExcelExportData(this.prisesVoixToExport);
            }
            else {
              this.toastService.show('Aucun texte correspondant aux critères n\'a pu être trouvés.', "warning");
            }

          },
          error: (error) => {
            console.error(error);
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          },
        });
  }

  onSmartSelectEnable() {
    this.limit = this.collectionSize;
    this.resetTextsToPatchList();
    this.getPVsList();
  }

  openRemoveTextDialog() {
    this.isPostingOver = false;
    this.isPosting = false;
    this.postError = null;
    this.showValidationDialog = !this.showValidationDialog;
  }

  sendTexts(notify: boolean = false) {
    this.isPosting = true;
    // Object to POST
    const body = {
      email: notify,
      PRISES_VOIX: this.textsToPatchList,
    };

    this.atsappService
      .unassignPVs(body)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        error: (error) => {
          this.playErrorSound();
          this.postError = {
            errorCode: error.error.code,
            message: error.error.message,
          };
          this.isPosting = false;
        },
        complete: () => {
          this.postError = null;
          this.isPosting = false;
          this.isPostingOver = true;
          this.resetTextsToPatchList();
          this.playSuccessSound();
        },
      });
  }

  filterSelectedText() : any[] {
    this.textsForPreview =[]
    return this.prisesVoix.filter(allSeensText => {
      return this.textsToPatchIdList.some(textToSee => {
        const partialIdText = textToSee.split('-')
        return partialIdText[0] === allSeensText.ZMS_NUMERO && partialIdText[1] === allSeensText.ZMS_LIVRAISON && partialIdText[2] === allSeensText.ZMS_MESSAGE && partialIdText[3]=== allSeensText.RANGPV && partialIdText[4] ===allSeensText.CLIENT_FINAL
      })
    });
  }

  showSelectedText(content : TemplateRef<any>) {
    this.textsForPreview = this.filterSelectedText()
    this.modalService.open(content, { size: 'xl', scrollable: true , centered: true})
  }

  showFocusSentText(text: any) {
    this.commonModalService.showModalFocus.subscribe((show) => {
      this.showFocusModalFromSent = show;
    })
    this.commonModalService.openFocusText(text)
  }
}
